import React from 'react';
import { FaHandsHelping } from 'react-icons/fa';
import childImage from '../assets/img/7.jpeg';

const Cause = () => {
  return (
    <div name='cause' className='w-full min-h-[60vh] bg-[#c6bab8] text-[#15381b] pt-28 pb-10'>
      <div className='container mx-auto lg:px-32 md:px-20 px-6'>
        <div className='flex flex-col md:flex-row justify-center items-center gap-5'>
          {/* Left Side */}
          <div className='md:w-1/2 md:mr-4 mb-8'>
            <div className='text-lg'>
              <h2 className='text-3xl font-semibold mb-8'>Every child deserves the opportunity to learn.</h2>
              <p className='mb-16'>
                When young people want to tell their story, we listen. These young people believe in a better tomorrow. They know they can break free from those who doubt their potential and limit their opportunities.
              </p>
              <img src={childImage} alt='Child' className='rounded-lg w-full h-auto lg:hidden md:hidden' />
              <p className='text-2xl mt-8 lg:mt-0 md:mt-0'>
              We provide opportunities for people from
                economically challenged background to improve themselves and their community, through
                scholarships and study loans.
              </p>
            </div>
            <a 
              href='https://iit.edu.ng/support/make-a-contribution' 
              target="_blank"
              rel="noopener noreferrer"
              className='inline-block mt-8 bg-[#15381b] text-white text-lg py-4 px-8 rounded-lg shadow-md hover:bg-gray-100 hover:text-[#15381b] focus:outline-none'
            >
              Support Our Cause
            </a>
          </div>
          
          {/* Right Side */}
          <div className='md:w-1/2 md:ml-4'>
            <img src={childImage} alt='Child' className='hidden md:block lg:block rounded-lg w-full h-auto' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cause;
